import { createAction, props } from '@ngrx/store';
import { AdvanceEventOutcomes, AdvanceEventOutcomesHistory, Inverter, InverterV2, Range, SystemEnergyState, SystemPowerState, EvChRT, EvChRTV2, AHEvChRT, EvChDataV2, AHheatPumpDAY, HeatPumpRTData } from 'ngx-core-services';

import { AlertContent } from '../../lib/alerts/alert.model';
import { blockInfo } from '../../lib/plant-card-overview/plant-card-overview.model';
import { TelemetryReportMode } from '../../lib/telemetry-report/telemetry-report.component';

export const requestSystemEnergyState = createAction(
  '[B - Totalizer] Request System Energy State',
  props<{ systemId: string, instanceId: string, forceRefresh: boolean }>()
);

export const updateSystemEnergyState = createAction(
  '[B - Totalizer] Update System Energy State',
  props<{ systemId: string, instanceId: string, systemEnergyState: SystemEnergyState }>()
);

export const setSystemEnergyStateError = createAction(
  '[B - Totalizer] Set System Energy State Error',
  props<{ systemId: string, instanceId: string, error: string }>()
);

export const requestSystemPowerState = createAction(
  '[B - Flow Chart] Request System Power State',
  props<{ systemId: string, instanceId: string, forceRefresh: boolean  }>()
);

export const updateSystemPowerState = createAction(
  '[B - Flow Chart] Update System Power State',
  props<{ systemId: string, instanceId: string, systemPowerState: SystemPowerState }>()
);

export const setSystemPowerStateError = createAction(
  '[B - Flow Chart] Set System Power State Error',
  props<{ systemId: string, instanceId: string, error: string }>()
);

export const requestSystemMonthlyYearlyEnergy = createAction(
  '[B - Monthly Yearly Energy] Request System Monthly Yearly Energy',
  props<{ systemId: string, instanceId: string, range: Range, mode: 'month'|'year', forceRefresh: boolean, deviceId?: string }>()
);

export const updateSystemMonthlyYearlyEnergy = createAction(
  '[B - Monthly Yearly Energy] Update System Monthly Yearly Energy',
  props<{ systemId: string, instanceId: string, range: Range,  mode: 'month'|'year',  systemEnergyState: Partial<Inverter>[],  deviceId?: string }>()
);

export const setSystemMonthlyYearlyEnergyError = createAction(
  '[B - Monthly Yearly Energy] Set System Monthly Yearly Energy Error',
  props<{ systemId: string, instanceId: string, error: string }>()
);

export const requestSystemEnergyDataOverview = createAction(
  '[B - Energy data overview] Request System Energy Data Overview',
  props<{ systemId: string, instanceId: string, range: Range, mode: 'day' | 'month' | 'year', forceRefresh: boolean }>()
);

export const updateSystemEnergyDataOverview = createAction(
  '[B - Energy data overview] Update System Energy Data Overview',
  props<{ systemId: string, instanceId: string, range: Range, mode: 'day' | 'month' | 'year', systemEnergyState: Partial<Inverter>[] }>()
);

export const setSystemEnergyDataOverviewError = createAction(
  '[B - Energy data overview] Set System Energy Data Overview Error',
  props<{ systemId: string, instanceId: string, error: string }>()
);

export const requestSystemDailyPowers = createAction(
  '[B - Daily State Overview] Request System Daily Powers',
  props<{ systemId: string, instanceId: string, range: Range, forceRefresh: boolean }>()
);

export const updateSystemDailyPowers = createAction(
  '[B - Daily State Overview] Update System Daily Powers',
  props<{ systemId: string, instanceId: string, range: Range, systemPowerState: Partial<InverterV2>[] }>()
);

export const setSystemDailyPowersError = createAction(
  '[B - Daily State Overview] Set System Daily Powers Error',
  props<{ systemId: string, instanceId: string, error: string }>()
);

export const requestSystemDailyEnergies = createAction(
  '[B - Daily State Overview] Request System Daily Energies',
  props<{ systemId: string, instanceId: string, range: Range, forceRefresh: boolean }>()
);

export const updateSystemDailyEnergies = createAction(
  '[B - Daily State Overview] Update System Daily Energies',
  props<{ systemId: string, instanceId: string, range: Range, systemEnergyState: Partial<InverterV2> }>()
);


export const setSystemDailyEnergiesError = createAction(
  '[B - Daily State Overview] Set System Daily Energies Error',
  props<{ systemId: string, instanceId: string, error: string }>()
);

export const requestSystemAlerts = createAction(
  '[B - Alerts List] Request System Alerts',
  props<{ systemId: string, instanceId: string, range: Range, forceRefresh: boolean, showAll: boolean }>()
);

export const updateSystemAlerts = createAction(
  '[B - Alerts List] Update System Alerts',
  props<{ systemId: string, instanceId: string, alerts: AlertContent, allTimestampsBySerial: { [serial: string]: number[] } }>()
);

export const setSystemAlertsError = createAction(
  '[B - Alerts List] Set System Alerts Error',
  props<{ systemId: string, instanceId: string, error: string }>()
);

export const requestSystemDeviceDetails = createAction(
  '[B - Device Details] Request System Device Details',
  props<{ systemId: string, instanceId: string, deviceId: string, forceRefresh: boolean }>()
);

export const updateSystemDeviceDetails = createAction(
  '[B - Device Details] Update System Device Details',
  props<{ systemId: string, instanceId: string, deviceId: string, deviceDetails: Partial<Inverter> }>()
);

export const setSystemDeviceDetailsError = createAction(
  '[B - Device Details] Set System Device Details Error',
  props<{ systemId: string, instanceId: string, error: string }>()
);

export const requestTelemetryReport = createAction(
  '[B - Telemetry Report] Request Telemetry Report',
  props<{ systemId: string, instanceId: string, deviceIds: string[], start: Date, end: Date, mode: TelemetryReportMode}>()
);

export const requestSystemCurrentEvents = createAction(
  '[B - Events List] Request System Current Events',
  props<{ systemId: string, instanceId: string, forceRefresh: boolean }>()
);

export const requestSystemHistoricalEvents = createAction(
  '[B - Events List] Request System Historical Events',
  props<{ systemId: string, instanceId: string, range: Range, forceRefresh: boolean}>()
);

export const updateSystemCurrentEvents = createAction(
  '[B - Events List] Update System Current Events',
  props<{ systemId: string, instanceId: string, events: Partial<AdvanceEventOutcomes>[] }>()
);
export const updateSystemHistoricalEvents = createAction(
  '[B - Events List] Update System Historical Events',
  props<{ systemId: string, instanceId: string, events: Partial<AdvanceEventOutcomesHistory>[] }>()
);

export const setSystemCurrentEventError = createAction(
  '[B - Events List] Set System Current Event Error',
  props<{ systemId: string, instanceId: string, error: string }>()
);

export const setSystemHistoricalEventError = createAction(
  '[B - Events List] Set System Historical Event Error',
  props<{ systemId: string, instanceId: string, error: string }>()
);

export const requestSystemsDevicesStatus = createAction(
  '[B - Device List] Request Systems Devices Status',
  props<{ systemId: string, instanceId: string, forceRefresh: boolean }>()
);

export const updateSystemsDevicesStatus = createAction(
  '[B - Device List] Update Systems Devices Status',
  props<{ systemId: string, instanceId: string, devices: { [key: string]: Partial<Inverter> } }>()
);

export const setSystemsDevicesStatusError = createAction(
  '[B - Device List] Set Systems Devices Status Error',
  props<{ systemId: string, instanceId: string, error: string }>()
);

export const requestSystemAlertsCount = createAction(
  '[B - Alerts Counter] Request System Alerts Count',
  props<{ systemId: string, instanceId: string, forceRefresh: boolean, showAll: boolean }>()
);

export const updateSystemAlertsCount = createAction(
  '[B - Alerts Counter] Update System Alerts Count',
  props<{ systemId: string, instanceId: string, alerts: AlertContent }>()
);

export const setSystemAlertsCountError = createAction(
  '[B - Alerts Counter] Set System Alerts Count Error',
  props<{ systemId: string, instanceId: string, error: string }>()
);

export const requestSystemDeviceDailyPowers = createAction(
  '[B - Daily Device Powers State] Request System Device Daily Powers',
  props<{ systemId: string, instanceId: string, deviceId: string, range: Range, forceRefresh: boolean }>()
);

export const updateSystemDeviceDailyPowers = createAction(
  '[B - Daily Device Powers State] Update System Device Daily Powers',
  props<{ systemId: string, instanceId: string, deviceId: string, range: Range, systemPowerState: Partial<InverterV2>[] }>()
);

export const setSystemDeviceDailyPowersError = createAction(
  '[B - Daily Device Powers State] Set System Device Daily Powers Error',
  props<{ systemId: string, instanceId: string, deviceId: string, error: string }>()
);

export const requestPlantCardBlocksToShow = createAction(
  '[B - Blocks] Request Blocks To Show',
  props<{ systemId: string, forceRefresh: boolean  }>()
);

export const updatePlantCardBlocksToShow = createAction(
  '[B - Blocks] Update Blocks To Show',
  props<{ systemId: string, blocks: blockInfo[] }>()
);

export const setPlantCardBlocksToShowError = createAction(
  '[B - Blocks] Set Blocks To Show Error',
  props<{ systemId: string, error: string }>()
);

export const requestPlantCardStatus = createAction(
  '[B - Plant Card] Request Plant Card Status',
  props<{ systemId: string, forceRefresh: boolean }>()
);

export const updatePlantCardStatus = createAction(
  '[B - Plant Card] Update Plant Card Status',
  props<{ systemId: string, plantStatus: "connectedAndUpdated" | "disconnected" | "notUpdated" | "updated", hasAlarms: boolean }>()
);

export const setPlantCardStatusError = createAction(
  '[B - Plant Card] Set Plant Card Status Error',
  props<{ systemId: string, error: string }>()
);

export const requestSystemEvchargeDailyTelemetry = createAction(
  '[B - EVCharge Telemetry] Request System EVCharge Daily Telemetry',
  props<{ systemId: string, instanceId: string, range: Range, deviceId: string, forceRefresh: boolean }>()
);

export const updateSystemEvchargeDailyTelemetry = createAction(
  '[B - EVCharge Telemetry] Update System EVCharge Daily Telemetry',
  props<{ systemId: string, instanceId: string, range: Range, deviceId: string, telemetryData: EvChRT[] | EvChRTV2[] | AHEvChRT[] }>()
);

export const setSystemEvchargeDailyTelemetryError = createAction(
  '[B - EVCharge Telemetry] Set System EVCharge Daily Telemetry Error',
  props<{ systemId: string, instanceId: string, deviceId: string, error: string }>()
);

export const requestSystemEvchargeEnergyAggregation = createAction(
  '[B - EVCharge Energy Aggregation] Request System EVCharge Energy Aggregation',
  props<{ systemId: string, instanceId: string, deviceId: string, period: 'month' | 'year', date: Date, forceRefresh: boolean }>()
);

export const updateSystemEvchargeEnergyAggregation = createAction(
  '[B - EVCharge Energy Aggregation] Update System EVCharge Energy Aggregation',
  props<{ systemId: string, instanceId: string, deviceId: string, period: 'month' | 'year', aggregationData: EvChDataV2[] }>()
);

export const setSystemEvchargeEnergyAggregationError = createAction(
  '[B - EVCharge Energy Aggregation] Set System EVCharge Energy Aggregation Error',
  props<{ systemId: string, instanceId: string, deviceId: string, period: 'month' | 'year', error: string }>()
);

export const requestSelectedHeatpumpCurrentData = createAction(
  '[B - Heatpump Current Data] Request Selected Heatpump Current Data',
  props<{ systemId: string, instanceId: string, deviceId: string, forceRefresh: boolean }>()
);

export const updateSelectedHeatpumpCurrentData = createAction(
  '[B - Heatpump Current Data] Update Selected Heatpump Current Data',
  props<{ systemId: string, instanceId: string, deviceId: string, heatpumpData: Partial<AHheatPumpDAY> }>()
);

export const setSelectedHeatpumpCurrentDataError = createAction(
  '[B - Heatpump Current Data] Set Selected Heatpump Current Data Error',
  props<{ systemId: string, instanceId: string, deviceId: string, error: string }>()
);

export const requestSelectedHeatpumpDailyTelemetryData = createAction(
  '[B - Heatpump Daily Telemetry Data] Request Selected Heatpump Daily Telemetry Data',
  props<{ systemId: string, instanceId: string, date: string, deviceId: string, forceRefresh: boolean }>()
);

export const updateSelectedHeatpumpDailyTelemetryData = createAction(
  '[B - Heatpump Daily Telemetry Data] Update Selected Heatpump Daily Telemetry Data',
  props<{ systemId: string, instanceId: string, deviceId: string, heatpumpData: Partial<HeatPumpRTData>[] }>()
);

export const setSelectedHeatpumpDailyTelemetryDataError = createAction(
  '[B - Heatpump Daily Telemetry Data] Set Selected Heatpump Daily Telemetry Data Error',
  props<{ systemId: string, instanceId: string, deviceId: string, error: string }>()
);

export const requestSystemHeatpumpEnergyAggregation = createAction(
  '[B - Heatpump Energy Aggregation] Request System Heatpump Energy Aggregation',
  props<{ systemId: string, instanceId: string, deviceId: string, period: 'month' | 'year', date: Date, forceRefresh: boolean }>()
);

export const updateSystemHeatpumpEnergyAggregation = createAction(
  '[B - Heatpump Energy Aggregation] Update System Heatpump Energy Aggregation',
  props<{ systemId: string, instanceId: string, deviceId: string, period: 'month' | 'year', aggregationData: Partial<AHheatPumpDAY>[] }>()
);

export const setSystemHeatpumpEnergyAggregationError = createAction(
  '[B - Heatpump Energy Aggregation] Set System Heatpump Energy Aggregation Error',
  props<{ systemId: string, instanceId: string, deviceId: string, period: 'month' | 'year', error: string }>()
);
